const routes = {
  createStore: 'store',
  getStores: 'store',
  getStoreById: 'store/',
  updateStore: 'store/',
  deleteStore: 'store/',
};

export default routes